import type { VFC } from 'react';
import React from 'react';
import { styled } from '@compiled/react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Box from '@atlaskit/primitives/box';
// oxlint-disable-next-line @atlaskit/design-system/no-emotion-primitives
import { xcss } from '@atlaskit/primitives/xcss';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FlexComment = styled.div({
	display: 'flex',
	flexWrap: 'wrap',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CommentContainer = styled.div({
	display: 'flex',
	flexBasis: '100%',
	marginBottom: token('space.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Circle = styled.div({
	backgroundColor: token('color.skeleton'),
	width: '32px',
	height: '32px',
	borderRadius: token('radius.full'),
	marginTop: token('space.050'),
	marginRight: token('space.150'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const BeforeStylesContainer = styled.div({
	content: ' ',
	display: 'block',
	marginBottom: token('space.200'),
	paddingTop: token('space.150'),
	borderBottom: `${token('border.width')} solid ${token('color.border')}`,
	width: '100%',
});

const commentWrapperStyles = xcss({
	marginTop: 'space.250',
	width: '100%',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CommentAddPromptContainer = styled.div({
	width: '100%',
	border: 'none',
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: token('radius.small', '3px'),
	height: '40px',
	color: token('color.text.subtlest'),
	paddingTop: token('space.0'),
	display: 'inline-block',
	verticalAlign: 'top',
	marginLeft: token('space.100'),
	flexGrow: 1,
	backgroundColor: token('color.skeleton'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const GridContainer = styled.div({
	display: 'grid',
	gridTemplateColumns: 'auto auto auto auto',
	gridGap: '10px',
	backgroundColor: 'transparent',
	width: '500px',
	marginLeft: token('space.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Author = styled.div({
	gridArea: '1 / 1 / span 1 / span 4',
	backgroundColor: token('color.skeleton'),
	textAlign: 'center',
	padding: `${token('space.150')} 0`,
	border: 'none',
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: token('radius.small', '3px'),
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const InnerComment = styled.div({
	gridArea: '2 / 1 / span 1 / span 10',
	backgroundColor: token('color.skeleton'),
	textAlign: 'center',
	padding: `${token('space.075')} 0`,
	border: 'none',
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: token('radius.small', '3px'),
});

type CommentPlaceholderProps = {
	showPlaceholder?: boolean;
};

export const CommentPlaceholder: VFC<CommentPlaceholderProps> = ({ showPlaceholder = false }) => {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR || window.__SSR_RENDERED__ || showPlaceholder) {
		return (
			<Box xcss={commentWrapperStyles} data-vc="comment-placeholder">
				<CommentContainer>
					<Circle />
					<GridContainer>
						<Author />
						<InnerComment />
					</GridContainer>
				</CommentContainer>
				<BeforeStylesContainer />
				<FlexComment data-testid="comment-container">
					<CommentContainer>
						<Circle />
						<CommentAddPromptContainer />
					</CommentContainer>
				</FlexComment>
			</Box>
		);
	} else {
		return null;
	}
};
